module.exports = __webpack_public_path__ + "img/QuaManageSys.3eb25c3b.jpg";